// 扫脸拍照 加密传参使用
const faceConfig = {
  dev: {
    appCode: "APP000000000053",
    appKey: "d3ab4202da9941118ad8838ffda6db38",
    appSecret:
      "JDJhJDEwJDFxUUVab0M2WHZVYXN6dXhESncxMXVlMUVGTjQwc1BReUF5NGFweXlqZlNNNnF4c0YwQ2wy"
  },
  fat: {
    appCode: "APP000000000026",
    appKey: "31d37d9d49474439a87e3b71d565b297",
    appSecret:
      "JDJhJDEwJHNzZWtnVDdTaUp4OWpXNi5NVXFqY3VsZG5tdkV0TU4vUWF3ckJUSXc5NGV6Q01JZUNFcEJl"
  },
  pre: {
    appCode: "APP000000000009",
    appKey: "dfe2bc6441564e17a7e8fbb96e666eb8",
    appSecret:
      "JDJhJDEwJFplYWM5Vk9oUFNRRHBZU3diRGJ4V2VjNjB2c3FSUzBWa251L1ZvQmMxZS9JRkFrUEhFQXFH"
  },
  prd: {
    appCode: "APP000000000005",
    appKey: "9a493d1f978741288bd511d8f1f3ce86",
    appSecret:
      "JDJhJDEwJFNBSm5TZ1hzMi9iR1R1aHBrdzVac3V6SjloeFFaOHVsS3BPU2RianZ5MXh6bGYwWU51YXlP"
  }
};
export function getFaceConfig() {
  const hostName = window.location.host;
  const port = window.location.port
  let key = 'dev';
  if (hostName.indexOf('anxinzp.com') > -1 || !!port) {
    key = "dev";
  } else if (hostName.indexOf('anxingongchang.com')>-1) {
    key = "fat";
  } else if (hostName.indexOf('huixiananxin.com')>-1 ) {
    key = "pre";
  } else {
    key = "prd";
  }
  return faceConfig[key]
}
